import React from "react";

function TermlyFeeInvoicesCount({termlyFeeCount}) {

    return (
        <div className="col-lg-12">
            <div className="card custom-card" style={{paddingBottom:"10px"}}>
            <div className="card-body map-card">
                <div className="item-title">
                <h5 style={{marginBottom:10}}>Termly Fee Invoice Count</h5>
                </div>
                <table className="table mb-0 color-span">
                <thead>
                <tr>
                <th className="w-50">Category</th>
                <th></th>
                <th className="py-2 px-0" scope="col">Count</th>
                </tr>
                </thead>
                <tbody>
                
        <tr>
          <td className="py-2 px-0">
            <span className="w-50">Total Invoices</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            {termlyFeeCount? termlyFeeCount?.total_invoices?.total_p:"..."}
            </span>
          </td>
        </tr>
        <tr>
          <td className="py-2 px-0">
            <span className="w-50">Fully Paid</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            {termlyFeeCount? termlyFeeCount?.fully_paid?.total_p:"..."}
            </span>
          </td>
        </tr>
        <tr>
          <td className="py-2 px-0">
            <span className="w-50">Partially Paid</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            {termlyFeeCount? termlyFeeCount?.partially_paid?.total_p:"..."}
            </span>
          </td>
        </tr>
    </tbody>
                </table>
            </div>
            </div>
        </div>
        
    );
}

export default TermlyFeeInvoicesCount;
